/*
 * @Author: shijianchen shijianchen@tujia.com
 * @Date: 2022-07-13 11:06:32
 * @LastEditors: shijian.chen shijian.chen@qunar.com
 * @LastEditTime: 2023-01-16 08:06:05
 * @FilePath: /dmf_ad_currency_h5/src/utils/getJson.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios from 'axios';
import { baseUrl } from '@/network/request';



export const submit = (activityCode,json)=>{
    eval(`window.editorJson = ${json};`);
      axios
        .post(
          baseUrl + '/webConfig/save',
          {
            activityCode: activityCode,
            configCode: activityCode,
            webJson: encodeURIComponent(JSON.stringify(editorJson || {})),
          },
          {
            headers: {
              'Content-Type': 'application/json; charset=utf-8',
            },
          },
        )
        .then((res) => {
          alert("提交成功")
        });
}

export const update =(activityCode,json)=> {
  axios
      .post(
        baseUrl + '/webConfig/query',
        {
          activityCode: activityCode,
          configCode: activityCode,
        },
        {
          headers: {
            'Content-Type': 'application/json; charset=utf-8',
          },
        },
      )
      .then((res) => {
        let id = res.data.data[0].id;
        eval(`window.editorJson = ${json};`);
        axios
          .post(
            baseUrl + '/webConfig/update',
            {
              activityCode: activityCode,
              configCode: activityCode,
              id:id,
              webJson: encodeURIComponent(JSON.stringify(editorJson || {})),
            },
            {
              headers: {
                'Content-Type': 'application/json; charset=utf-8',
              },
            },
          )
          .then((res) => {});
            });
}

export const query =(activityCode)=> {
  return new Promise((resolve)=>{
    axios
      .post(
        baseUrl + '/webConfig/query',
        {
          activityCode: activityCode,
          configCode: activityCode,
        },
        {
          headers: {
            'Content-Type': 'application/json; charset=utf-8',
          },
        },
      )
      .then((res) => {
        resolve(JSON.parse(decodeURIComponent(res.data.data ? res.data.data[0].webJson : "{}")))
      });
  })
}

